import React from 'react';
import ShownPanelsEnum from '../../../../Enums/ShownPanelsEnum';
import TabOfDataTable from '../../../../Elements/DataTable/TabOfDataTable';
import OrderDirectionsEnum from '../../../../Enums/OrderDirectionsEnum';
import ButtonTypeEnum from '../../../../Enums/ButtonTypeEnum';
import ButtonColorsEnum from '../../../../Enums/ButtonColorsEnum';
import IconPositionEnum from '../../../../Enums/IconPositionEnum';
import FigmaButtonRow from '../../../../Elements/FigmaButtonRow';
import ThirdPartyJobPaymentsAdminSearchParams from './ThirdPartyJobPaymentsAdminSearchParams';
import ThirdPartyJobPaymentsAdminItem from '../../../../Domain/ThirdParty/ThirdPartyJobPayments/ThirdPartyJobPaymentsAdminItem';
import ThirdPartyJobPaymentsService from '../../../../Services/ThirdParty/ThirdPartyJobPaymentsService';
import TpJobEvaluatorPaymentsTabSearchParams from './TpJobEvaluatorPaymentsTabSearchParams';
import PendingApprovalTpJobEvaluatorPaymentsTabSearchParams from './PendingApprovalTpJobEvaluatorPaymentsTabSearchParams';
import AuthService from '../../../../Services/authService';
import OfficeHelper from '../../../../Helpers/ModelHelpers/OfficeHelper';
import VoidWindowDescription from './Actions/VoidWindowDescription';
import VoidAndReissueWindowDescription from './Actions/VoidAndReissueWindowDescription';
import VoidAndSupressWindowDescription from './Actions/VoidAndSupressWindowDescription';
import ApproveWindowDescription from './Actions/ApproveWindowDescription';
import EvaluatorPaymentActionParamsItem from '../../../Evaluator/EvaluatorAdmin/EvaluatorPayments/EvaluatorPaymentActionParamsItem';
import ThirdPartyJobPaymentsItem from '../../../../Domain/ThirdParty/ThirdPartyJobPayments/ThirdPartyJobPaymentsItem';
import GeneralEditWizzardBase from '../../../../Elements/GeneralEditWizzard/GeneralEditWizzardBaseFigma';
import CrudTypesEnum from '../../../../Enums/CrudTypesEnum';
import EditTpEvaluatorTpJobPaymentWindowDescription from './EditTpEvaluatorTpJobPaymentWindowDescription';
import EditTpAdvancePaymentWindowDescription from './EditTpAdvancePaymentWindowDescription';
import TpPaymentRequestStatusChangeWindowDescription from './TpPaymentRequestStatusChangeWindowDescription';
import TpEvaluatorPaymentsSearchParams from './TpEvaluatorPaymentsSearchParams';
import EvaluatorPaymentViewsEnum from '../../../../Enums/EvaluatorPaymentViewsEnum';

export default class ThirdPartyJobPaymentsAdmin extends React.Component {
  constructor(props) {
    super(props);

    const typeOfSearch = this.getType();

    let searchItem = new ThirdPartyJobPaymentsAdminSearchParams();
    if (
      typeOfSearch === 'all_payments' ||
      typeOfSearch === 'pending_approval' ||
      typeOfSearch === 'pending_approval_vat' ||
      typeOfSearch === 'pending_review'
    ) {
      if (typeOfSearch === 'all_payments') {
        searchItem = new TpJobEvaluatorPaymentsTabSearchParams();
      } else if (typeOfSearch === 'pending_approval') {
        searchItem = new PendingApprovalTpJobEvaluatorPaymentsTabSearchParams();
      }
      if (props.tpEvaluatorId) {
        searchItem = new TpEvaluatorPaymentsSearchParams();
        searchItem.TpEvaluatorId = props.tpEvaluatorId;
      }
      searchItem.TabType = typeOfSearch;
      searchItem.ThirdPartyJobId = props.tpJob?.ThirdPartyJobId;
      searchItem.ThirdPartySource = props.tpJob?.ThirdPartySource;
      searchItem.SelectedPaymentOffices = [];

      if (typeOfSearch === 'pending_approval') {
        searchItem.SearchType = EvaluatorPaymentViewsEnum.AllPendingApproval;
      } else if (typeOfSearch === 'pending_review') {
        searchItem.SearchType = EvaluatorPaymentViewsEnum.PendingReview;
      } else if (typeOfSearch === 'pending_approval_vat') {
        searchItem.SearchType = EvaluatorPaymentViewsEnum.PendingApprovalVAT;
      }
    }

    this.state = {
      searchItem,
      shownPanel: ShownPanelsEnum.None,
      itemList: [],
      popup: null,
    };

    this.startSearch = this.startSearch.bind(this);
    this.renderActionButtons = this.renderActionButtons.bind(this);
    ThirdPartyJobPaymentsItem.actionFunction = this.clickOnAction.bind(this);
    ThirdPartyJobPaymentsItem.editFunction = this.clickOnEdit.bind(this);
    ThirdPartyJobPaymentsItem.statusChangeFunction = this.statusChangeFunction.bind(this);
  }

  getType() {
    return '';
  }

  statusChangeFunction(item) {
    this.setState({
      shownPanel: ShownPanelsEnum.StatusUpdate,
      selectedItem: item,
    });
  }

  clickOnEdit(payment) {
    this.setState({
      shownPanel: ShownPanelsEnum.EditItem,
      selected: payment.TpEvaluatorTpJobPaymentId,
      selectedItem: payment,
    });
  }

  editPanelOnClose() {
    this.setState({ shownPanel: ShownPanelsEnum.None });
  }

  savePanelOnClose() {
    this.setState({ shownPanel: ShownPanelsEnum.None, searchItem: { ...this.state.searchItem } });
  }

  renderPanels() {
    if (this.state.shownPanel === ShownPanelsEnum.EditItem) {
      return (
        <GeneralEditWizzardBase
          crudType={CrudTypesEnum.Update}
          editedItem={this.state.selectedItem}
          clickOnCancel={this.editPanelOnClose.bind(this)}
          clickOnSave={this.savePanelOnClose.bind(this)}
          windowDescription={EditTpEvaluatorTpJobPaymentWindowDescription}
          errorCode={'TPJPA101'}
        />
      );
    }

    if (this.state.shownPanel === ShownPanelsEnum.AddNewItem) {
      return (
        <GeneralEditWizzardBase
          crudType={CrudTypesEnum.Create}
          editedItem={
            new ThirdPartyJobPaymentsAdminItem({
              tpJobId: this.props.tpJob.TpJobId,
              evaluatorCurrencyCode: this.props.tpJob.EvaluatorCurrencyCode,
              evaluatorCurrencySymbol: this.props.tpJob.EvaluatorCurrencySymbol,
              evaluatorCurrencyId: this.props.tpJob.EvaluatorCurrencyId,
            })
          }
          clickOnCancel={this.editPanelOnClose.bind(this)}
          clickOnSave={this.savePanelOnClose.bind(this)}
          windowDescription={EditTpEvaluatorTpJobPaymentWindowDescription}
          errorCode={'TPJPA120'}
        />
      );
    }

    if (this.state.shownPanel === ShownPanelsEnum.AddNewSubItem) {
      return (
        <GeneralEditWizzardBase
          crudType={CrudTypesEnum.Create}
          editedItem={
            new ThirdPartyJobPaymentsAdminItem({
              tpJobId: this.props.tpJob.TpJobId,
              evaluatorCurrencyCode: this.props.tpJob.EvaluatorCurrencyCode,
              evaluatorCurrencySymbol: this.props.tpJob.EvaluatorCurrencySymbol,
              evaluatorCurrencyId: this.props.tpJob.EvaluatorCurrencyId,
              typeText: 'Advance Payment',
              paymentTypeText: 'Check',
            })
          }
          clickOnCancel={this.editPanelOnClose.bind(this)}
          clickOnSave={this.savePanelOnClose.bind(this)}
          windowDescription={EditTpAdvancePaymentWindowDescription}
        />
      );
    } else if (this.state.shownPanel === ShownPanelsEnum.StatusUpdate) {
      return (
        <GeneralEditWizzardBase
          crudType={CrudTypesEnum.Update}
          editedItem={{
            ...this.state.selectedItem,
            Id: this.state.selectedItem.TpEvaluatorTpJobPaymentId,
            Comment: '',
          }}
          clickOnCancel={this.editPanelOnClose.bind(this)}
          clickOnSave={this.savePanelOnClose.bind(this)}
          windowDescription={TpPaymentRequestStatusChangeWindowDescription}
        />
      );
    }
  }

  clickOnAction(paymentIds, actionType) {
    let windowDescription = null;
    switch (actionType) {
      case 'Void':
        windowDescription = VoidWindowDescription;
        break;
      case 'VoidAndReissue':
        windowDescription = VoidAndReissueWindowDescription;
        break;
      case 'VoidAndSupress':
        windowDescription = VoidAndSupressWindowDescription;
        break;
      default:
        windowDescription = ApproveWindowDescription;
    }

    const paramsData = new EvaluatorPaymentActionParamsItem(
      paymentIds,
      this.state.allItemsInTheSearchSetAreSelected,
      this.state.searchItem
    );

    const closeAndRefresh = () => {
      this.startSearch({ ...this.state.searchItem });
      this.setState({ popup: null });
    };

    this.setState({
      popup: (
        <GeneralEditWizzardBase
          crudType={CrudTypesEnum.Update}
          editedItem={paramsData}
          clickOnCancel={closeAndRefresh}
          clickOnSave={closeAndRefresh}
          windowDescription={windowDescription}
        />
      ),
    });
  }

  renderActionButtons() {
    if (this.getType() === 'all_payments' || this.getType() === 'pending_review') {
      const actionsDisabled = !this.state.itemList.find(
        (payment) => payment.Selected && payment.TypeText !== 'Payment Request'
      );

      const reissueDisabled =
        actionsDisabled || this.state.itemList.some((payment) => payment.TypeText === 'Advance Payment');

      const userOfficeId = AuthService.getInstance().GetLoggedInUser().officeId;

      // prettier-ignore
      const areOfficesTheSame =
        AuthService.IsAdmin()
        ? true
        : !this.props.assignment
          ? false
          : OfficeHelper.IsSameOfficeGroup(userOfficeId, this.props.assignment.asLdvid);

      return (
        <FigmaButtonRow
          className={'InnerMenuButtonFigmaList'}
          buttons={[
            {
              iconName: 'fa-regular fa-plus',
              type: ButtonTypeEnum.NormalIconOnly,
              color: ButtonColorsEnum.Destruct,
              iconPosition: IconPositionEnum.Center,
              onClick: () => this.clickOnNewPaymentRequest(),
              tooltip: 'New Payment Request',
              roleKey: 'EvaluatorPayment_FigmaButtonRowButton',
              disabled: !this.state.isNewPaymentRequestEnabled,
              hidden: !this.props.newButtonsEnabled,
            },
            {
              iconName: 'fa-regular fa-circle-plus',
              type: ButtonTypeEnum.NormalIconOnly,
              color: ButtonColorsEnum.Destruct,
              iconPosition: IconPositionEnum.Center,
              onClick: () => this.clickOnNewAdvancePayment(),
              tooltip: 'New Advance Payment',
              roleKey: 'EvaluatorPayment_NewAdvancePaymentButton',
              disabled: !this.state.isNewAdvancePaymentEnabled || !areOfficesTheSame,
              hidden: !this.props.newButtonsEnabled,
            },
            {
              iconName: 'fa-regular fa-check',
              type: ButtonTypeEnum.NormalIconOnly,
              color: ButtonColorsEnum.Destruct,
              iconPosition: IconPositionEnum.Center,
              onClick: () =>
                this.clickOnAction(
                  this.state.itemList
                    .filter((payment) => payment.Selected && payment.TypeText !== 'Payment Request')
                    .map((payment) => payment.TpEvaluatorTpJobPaymentId),
                  'Approve'
                ),
              tooltip: 'Approve',
              roleKey: 'EvaluatorPayment_FigmaButtonRowButton',
              disabled: actionsDisabled,
              hidden: !this.props.newButtonsEnabled,
            },
            {
              iconName: 'fa-regular fa-xmark',
              type: ButtonTypeEnum.NormalIconOnly,
              color: ButtonColorsEnum.Destruct,
              iconPosition: IconPositionEnum.Center,
              onClick: () =>
                this.clickOnAction(
                  this.state.itemList
                    .filter((payment) => payment.Selected && payment.TypeText !== 'Payment Request')
                    .map((payment) => payment.TpEvaluatorTpJobPaymentId),
                  'Void'
                ),
              tooltip: 'Void',
              roleKey: 'EvaluatorPayment_FigmaButtonRowButton',
              disabled: actionsDisabled,
            },
            {
              iconName: 'fa-solid fa-rotate-right',
              type: ButtonTypeEnum.NormalIconOnly,
              color: ButtonColorsEnum.Secondary,
              iconPosition: IconPositionEnum.Center,
              onClick: () =>
                this.clickOnAction(
                  this.state.itemList
                    .filter((payment) => payment.Selected && payment.TypeText !== 'Payment Request')
                    .map((payment) => payment.TpEvaluatorTpJobPaymentId),
                  'VoidAndReissue'
                ),
              tooltip: 'Void & Reissue',
              roleKey: 'EvaluatorPayment_FigmaButtonRowButton',
              disabled: reissueDisabled,
            },
            {
              iconName: 'fa-solid fa-trash',
              type: ButtonTypeEnum.NormalIconOnly,
              color: ButtonColorsEnum.Secondary,
              iconPosition: IconPositionEnum.Center,
              onClick: () =>
                this.clickOnAction(
                  this.state.itemList
                    .filter((payment) => payment.Selected && payment.TypeText !== 'Payment Request')
                    .map((payment) => payment.TpEvaluatorTpJobPaymentId),
                  'VoidAndSupress'
                ),
              tooltip: 'Void & Supress',
              roleKey: 'EvaluatorPayment_FigmaButtonRowButton',
              disabled: actionsDisabled,
            },
          ]}
        />
      );
    }

    const disabled = !this.state.itemList.find((payment) => payment.Selected);
    const reissueDisabled = disabled || this.state.itemList.some((payment) => payment.TypeText === 'Advance Payment');

    if (this.getType() === 'pending_approval' || this.getType() === 'pending_approval_vat') {
      return (
        <FigmaButtonRow
          className='InnerMenuButtonFigmaList'
          buttons={[
            {
              iconName: 'fa-regular fa-check',
              type: ButtonTypeEnum.NormalIconOnly,
              color: ButtonColorsEnum.Destruct,
              iconPosition: IconPositionEnum.Center,
              onClick: () =>
                this.clickOnAction(
                  this.state.itemList
                    .filter((payment) => payment.Selected && payment.TypeText !== 'Payment Request')
                    .map((payment) => payment.TpEvaluatorTpJobPaymentId),
                  'Approve'
                ),
              tooltip: 'Approve',
              roleKey: 'EvaluatorPayment_FigmaButtonRowButton',
              disabled,
            },
            {
              iconName: 'fa-regular fa-xmark',
              type: ButtonTypeEnum.NormalIconOnly,
              color: ButtonColorsEnum.Destruct,
              iconPosition: IconPositionEnum.Center,
              onClick: () =>
                this.clickOnAction(
                  this.state.itemList
                    .filter((payment) => payment.Selected && payment.TypeText !== 'Payment Request')
                    .map((payment) => payment.TpEvaluatorTpJobPaymentId),
                  'Void'
                ),
              tooltip: 'Void',
              roleKey: 'EvaluatorPayment_FigmaButtonRowButton',
              disabled,
            },
            {
              iconName: 'fa-solid fa-rotate-right',
              type: ButtonTypeEnum.NormalIconOnly,
              color: ButtonColorsEnum.Secondary,
              iconPosition: IconPositionEnum.Center,
              onClick: () =>
                this.clickOnAction(
                  this.state.itemList
                    .filter((payment) => payment.Selected && payment.TypeText !== 'Payment Request')
                    .map((payment) => payment.TpEvaluatorTpJobPaymentId),
                  'VoidAndReissue'
                ),
              tooltip: 'Void & Reissue',
              roleKey: 'EvaluatorPayment_FigmaButtonRowButton',
              disabled: reissueDisabled,
            },
            {
              iconName: 'fa-solid fa-trash',
              type: ButtonTypeEnum.NormalIconOnly,
              color: ButtonColorsEnum.Secondary,
              iconPosition: IconPositionEnum.Center,
              onClick: () =>
                this.clickOnAction(
                  this.state.itemList
                    .filter((payment) => payment.Selected && payment.TypeText !== 'Payment Request')
                    .map((payment) => payment.TpEvaluatorTpJobPaymentId),
                  'VoidAndSupress'
                ),
              tooltip: 'Void & Supress',
              roleKey: 'EvaluatorPayment_FigmaButtonRowButton',
              disabled,
            },
          ]}
        />
      );
    }

    return (
      <FigmaButtonRow
        buttons={[
          {
            iconName: 'fa-regular fa-check',
            type: ButtonTypeEnum.NormalIconOnly,
            color: ButtonColorsEnum.Destruct,
            iconPosition: IconPositionEnum.Center,
            onClick: () =>
              this.clickOnAction(
                this.state.itemList
                  .filter((payment) => payment.Selected)
                  .map((payment) => payment.TpEvaluatorTpJobPaymentId),
                'Approve'
              ),
            tooltip: 'Approve',
            roleKey: 'EvaluatorPayment_FigmaButtonRowButton',
            disabled,
          },
          {
            iconName: 'fa-regular fa-xmark',
            type: ButtonTypeEnum.NormalIconOnly,
            color: ButtonColorsEnum.Destruct,
            iconPosition: IconPositionEnum.Center,
            onClick: () =>
              this.clickOnAction(
                this.state.itemList
                  .filter((payment) => payment.Selected)
                  .map((payment) => payment.TpEvaluatorTpJobPaymentId),
                'Void'
              ),
            tooltip: 'Void',
            roleKey: 'EvaluatorPayment_FigmaButtonRowButton',
            disabled,
          },
          {
            iconName: 'fa-solid fa-rotate-right',
            type: ButtonTypeEnum.NormalIconOnly,
            color: ButtonColorsEnum.Secondary,
            iconPosition: IconPositionEnum.Center,
            onClick: () =>
              this.clickOnAction(
                this.state.itemList
                  .filter((payment) => payment.Selected)
                  .map((payment) => payment.TpEvaluatorTpJobPaymentId),
                'VoidAndReissue'
              ),
            tooltip: 'Void & Reissue',
            roleKey: 'EvaluatorPayment_FigmaButtonRowButton',
            disabled: reissueDisabled,
          },
          {
            iconName: 'fa-solid fa-trash',
            type: ButtonTypeEnum.NormalIconOnly,
            color: ButtonColorsEnum.Secondary,
            iconPosition: IconPositionEnum.Center,
            onClick: () =>
              this.clickOnAction(
                this.state.itemList
                  .filter((payment) => payment.Selected)
                  .map((payment) => payment.TpEvaluatorTpJobPaymentId),
                'VoidAndSupress'
              ),
            tooltip: 'Void & Supress',
            roleKey: 'EvaluatorPayment_FigmaButtonRowButton',
            disabled,
          },
        ]}
      />
    );
  }

  startSearch(searchItem) {
    searchItem.TabType = this.getType();
    if (this.props.tpJob) {
      searchItem.ThirdPartyJobId = this.props.tpJob.ThirdPartyJobId;
    }
    if (this.props.tpEvaluatorId) {
      searchItem.TpEvaluatorId = this.props.tpEvaluatorId;
    }
    if (this.getType() === 'pending_approval') {
      searchItem.SearchType = EvaluatorPaymentViewsEnum.AllPendingApproval;
    }
    if (this.getType() === 'pending_review') {
      searchItem.SearchType = EvaluatorPaymentViewsEnum.PendingReview;
    }
    if (this.getType() === 'pending_approval_vat') {
      searchItem.SearchType = EvaluatorPaymentViewsEnum.PendingApprovalVAT;
    }

    this.setState({ searchItem });
  }

  getSearchParamsType() {
    if (this.props.tpEvaluatorId) {
      return TpEvaluatorPaymentsSearchParams;
    }

    return this.getType() === 'all_payments'
      ? TpJobEvaluatorPaymentsTabSearchParams
      : this.getType() === 'pending_approval'
      ? PendingApprovalTpJobEvaluatorPaymentsTabSearchParams
      : ThirdPartyJobPaymentsAdminSearchParams;
  }

  render() {
    return (
      <div className='contentwrapper'>
        {this.state.popup}
        {this.renderActionButtons()}
        {this.renderPanels()}
        <TabOfDataTable
          type={ThirdPartyJobPaymentsAdminItem}
          shownPanel={this.state.shownPanel}
          serviceFunction={ThirdPartyJobPaymentsService.GetTpEvaluatorTpJobPayments}
          convertDBItemsFunction={ThirdPartyJobPaymentsService.ConvertDBItems}
          searchItem={this.state.searchItem}
          orderDirection={OrderDirectionsEnum.Asc}
          orderBy='AsEvname'
          itemList={this.state.itemList}
          changeOfItemListFunction={(itemList) => this.setState({ itemList })}
          showSearchStrip={true}
          searchParamsType={this.getSearchParamsType()}
          enableUrlPush={false}
          changeOfAllItemsAreSelectedFunction={(allItemsInTheSearchSetAreSelected) => {
            this.setState({ allItemsInTheSearchSetAreSelected });
          }}
          clickOnStartSearch={this.startSearch}
          singleSearchLine={true}
          singleSearchLinePlaceholder='Search in Clients, Evaluators, Projects, Third-Party Job IDs or Pay IDs...'
          useClickOnClearAll={true}
        />
      </div>
    );
  }
}
